var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 236,
    height: 237,
    viewBox: "0 0 236 237",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 24.478 17.871 C 22.266 18.876, 19.013 21.141, 17.250 22.903 C 11.025 29.129, 11 29.444, 11 100.920 L 11 165.477 27.261 149.239 L 43.522 133 59.167 133 L 74.813 133 75.175 151.750 C 75.481 167.591, 75.824 171.043, 77.386 174 C 79.974 178.901, 82.853 181.846, 87.500 184.347 C 91.408 186.450, 92.680 186.512, 142.742 187 L 193.984 187.500 209.526 203.127 L 225.067 218.753 224.784 152.127 C 224.503 86.098, 224.481 85.464, 222.347 81.500 C 219.853 76.865, 216.917 73.990, 212 71.367 C 208.924 69.726, 205.621 69.460, 184.750 69.171 L 161 68.841 160.994 52.671 C 160.991 43.777, 160.504 34.700, 159.912 32.500 C 158.213 26.193, 154.308 21.332, 148.691 18.533 L 143.607 16 86.054 16.022 C 32.477 16.042, 28.222 16.170, 24.478 17.871 M 33 74.500 L 33 112 86 112 L 139 112 139 74.500 L 139 37 86 37 L 33 37 33 74.500 M 160.809 104.250 C 160.355 118.453, 159.052 122.835, 153.834 127.702 C 148.665 132.524, 145.671 133, 120.532 133 L 97 133 97 149 L 97 165 150 165 L 203 165 203 128 L 203 91 182.116 91 L 161.232 91 160.809 104.250",
    stroke: "none",
    fill: "#4c39a0",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.d587e7d396db1e8919c6647ab22c40f2.svg";
export { ForwardRef as ReactComponent };